import { Component, OnInit } from '@angular/core';
import { PerfilService } from 'src/app/service/perfil.service';
import { LoginService } from 'src/app/service/login.service';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html'
})
export class PerfilComponent implements OnInit {
  edit = false;
  editDni: string;
  email: any;
  direccion: string;
  telefono: string;
  msjModal: any;
  dni: any;
  sesion: any
  sexo: any
  user: any = {
    nombres: ''
  };
  loading: boolean = true
  btnEditar: boolean = false;
  btnGuardar: boolean = false;
  despliegaModal: boolean = false;
  constructor(private perfil: PerfilService, private login: LoginService) {
    this.sesion = JSON.parse(localStorage.getItem('sesionPocae'));
    this.user.nombres = localStorage.getItem('nombre');
  }

  ngOnInit() {
    this.btnEditar = true;
    this.loadPerfil();
  }

  loadPerfil() {
    let json = {
      KSI: this.sesion.ksi,
      idUsuarioWeb: this.sesion.idUsuario
    }
    this.perfil.loadUser(json).subscribe(res => {
      this.user = res;
      localStorage.setItem('nombre', this.user.nombres);
      this.email = this.user.correo;
      this.loading = false;
      if (this.user.sexo == "F") {
        this.sexo = "Femenino"
      } else {
        this.sexo = "Masculino"
      }
    })
  }

  comproboEmail() {

    let mailValido = false;
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.email.match(EMAIL_REGEX)) {
      mailValido = true;
    }

    return mailValido;
  }

  editar() {
    this.btnEditar = false;
    this.btnGuardar = true;
  }

  guardarDatos() {
    this.loading = true;
    if (this.email !== "") {
      if (this.comproboEmail()) {
        let json = {
          KSI: this.sesion.ksi,
          idUsuarioWeb: this.sesion.idUsuario,
          correo: this.email,
          direccion: this.direccion,
          telefono: this.telefono
        }
        this.perfil.updateUser(json).subscribe(res => {
          if (res) {
            if (res.numError != 0) {
              if (res.numError === 2000) {
                this.loadPerfil();
                this.despliegaModal = true;
                this.loading = false;
                this.msjModal = "Error al actualizar los datos.";
              }
              else {
                this.loadPerfil();
                this.despliegaModal = true;
                this.loading = false;
                this.msjModal = res.msjError;
                this.edit = false
              }
            } else {
              this.despliegaModal = true;
              this.loading = false;
              this.msjModal = res.msjError;
              this.edit = false
            }
          } else {
            this.despliegaModal = true;
            this.loading = false;
            this.msjModal = "Error al actualizar los datos. Intente más tarde.";
          }
        }, () => {
          this.despliegaModal = true;
          this.loading = false;
          this.msjModal = "Error al conectar con el servicio. Intente más tarde.";
        })

        this.btnGuardar = false;
        this.btnEditar = true;
      }
      else {
        this.loadPerfil();
        this.despliegaModal = true;
        this.loading = false;
        this.msjModal = "Error al actualizar correo. Correo inválido";
        this.btnEditar = false;
        this.btnGuardar = true;
      }
    }
    else {
      this.loadPerfil();
      this.despliegaModal = true;
      this.msjModal = "Error al actualizar correo. Correo vacío.";
      this.btnEditar = false;
      this.btnGuardar = true;
    }
  }

  editPerfil(response: boolean) {
    this.edit = response
  }

  closeModal() {
    this.despliegaModal = false;
  }

}
